import React, { FunctionComponent } from 'react';
import Result from '../../components/Result/Result';
import { useTranslation } from 'react-i18next';
import { Question } from '../../App.styles';
import { ModelBrand, ResultInfo } from '../../components/Result/Result.styles';
import { Button, NavFooter } from '../../components';
import {
  TestId,
  closeAmzModal,
  iconUrl,
  imagesUrl,
  isAmazonHost,
} from '../../utils';
import {
  FlowStep,
  GlobalContext,
  StepperContext,
  updateFlowStep,
} from '../../contexts';
import { useTimeSpentMetric } from '../../hooks';

const NotCompatible: FunctionComponent = () => {
  const { stepperData } = React.useContext(StepperContext);
  const { dispatch } = React.useContext(GlobalContext);
  const { brand, model } = stepperData
    ? stepperData
    : { brand: undefined, model: undefined };
  const { t } = useTranslation('common');

  useTimeSpentMetric('notCompatible');

  return (
    <Result
      image={{
        source: imagesUrl.not_compatible,
        altText: t('images.notCompatible'),
      }}
    >
      <div className="row h-100 flex-column" data-testid={TestId.NotCompatible}>
        <div className="flex-grow-1">
          <div className="mt-2 mt-md-4">
            <img src={iconUrl.disabledCircle} alt="disabled"></img>
          </div>

          <Question className="my-3">
            {t('results.notCompatible.title')}
          </Question>

          <ResultInfo>
            <span>{t('results.notCompatible.description')}</span>
            {brand && model ? (
              <span>
                :
                <ModelBrand>
                  {brand}, {model.model_name}.
                </ModelBrand>
              </span>
            ) : (
              <span>.</span>
            )}
            <span> {t('results.notCompatible.description2')}</span>
          </ResultInfo>
        </div>

        <NavFooter>
          {isAmazonHost() ? (
            <>
              <Button type="button" onClick={closeAmzModal}>
                {t('header.close')}
              </Button>
              <Button
                type="button"
                ghost
                onClick={() => {
                  dispatch(
                    updateFlowStep({ flowStep: FlowStep.compatibilityChecker })
                  );
                }}
              >
                {t('header.back')}
              </Button>
            </>
          ) : (
            <a href={t('results.homeUrl')}>
              <Button type="button" className="w-100">
                {t('results.shopRing')}
              </Button>
            </a>
          )}
        </NavFooter>
      </div>
    </Result>
  );
};

export default NotCompatible;
